import {
    CodeEmail,
    EmailPasswordRecovery,
    ICodeEmail,
    IEmailPasswordRecovery,
    ILoginEmail,
    INewPassword,
    IRegData,
    LoginEmail,
    NewPassword,
    RegData
} from "@/models/auth";
import {FormikConfig} from "@/types/formik-config";
import {apiConfig} from "@/store";
import {FormActive} from "@/types/login-form-active";
import {
    loginEmail,
    postCodeEmail,
    postEmailPasswordRecovery,
    postRegData,
    renewCodeEmail,
    setPassword
} from "@/api/auth";

export function onSubmitLoginEmail(
    formik: FormikConfig<ILoginEmail>,
    navigate: (path: string) => void
): void {
    loginEmail(new LoginEmail(formik.values))
        .then(() => {
            apiConfig.isAuth && navigate("/")
        })
}

export function onSubmitRegData(
    formik: FormikConfig<IRegData>,
    setFormActive: (formActive: FormActive) => void,
): void {
    postRegData(new RegData(formik.values)).then(()=>{
        if (apiConfig.endpoints.postRegData.state === "success") {
            setFormActive(FormActive.Code)
        }
    })
}
export function onSubmitCodeEmail(
    formik: FormikConfig<ICodeEmail>,
    setFormActive: (formActive: FormActive) => void,
): void {
    postCodeEmail(new CodeEmail(formik.values)).then(()=>{
        if (apiConfig.endpoints.postCodeEmail.state === "success") {
            apiConfig.setInfo("Вы успешно подтвердили свой email. Установите пароль!")
            setFormActive(FormActive.Password)
        }
    })
}

export function onSubmitRenewCodeEmail(): void {
    renewCodeEmail().finally()
}


export function onSubmitSendEmailPasswordRecovery(
    formik: FormikConfig<IEmailPasswordRecovery>,
    setFormActive: (formActive: FormActive) => void,
): void {
    postEmailPasswordRecovery(new EmailPasswordRecovery(formik.values)).then(()=>{
        if (apiConfig.endpoints.postEmailPasswordRecovery.state === "success") {
            setFormActive(FormActive.Code)
        }
    })
}

export function onSubmitSetPassword(
    formik: FormikConfig<INewPassword>,
    setFormActive: (formActive: FormActive) => void,
): void {
    setPassword(new NewPassword(formik.values)).then(()=>{
        console.log(apiConfig.endpoints.setPassword.state)
        if (apiConfig.endpoints.setPassword.state === "success") {
            setFormActive(FormActive.Login);
        }
    });
    setFormActive(FormActive.Login);
}